import { PageHeader } from "@/components/shared";
import LiveMap, { useLiveMap } from "@/components/map/LiveMap";
import { Navigation, MapPin, CircleOff } from "lucide-react";

const ICONS = { gps: Navigation, scheduled: MapPin, off: CircleOff };

export function CleanerLegend({ cleaners = [] }) {
  if (!cleaners.length) return <p className="text-sm text-muted-foreground">No active cleaners.</p>;
  return (
    <div className="space-y-2" data-testid="map-legend">
      {cleaners.map((c) => {
        const Icon = ICONS[c.source];
        return (
          <div key={c.id} className="flex items-center gap-3 rounded-sm border border-border/60 bg-card px-4 py-3" data-testid={`map-cleaner-${c.id}`}>
            <span className="w-3.5 h-3.5 rounded-full shrink-0" style={{ backgroundColor: c.color, opacity: c.source === "off" ? 0.35 : 1 }} />
            <div className="min-w-0 flex-1">
              <div className="text-sm font-medium truncate">{c.name}</div>
              <div className="text-xs text-muted-foreground truncate">{c.client ? `${c.client}` : "—"}</div>
            </div>
            <span className={`inline-flex items-center gap-1 text-xs ${c.source === "gps" ? "text-[hsl(140_60%_35%)]" : "text-muted-foreground"}`} data-testid={`map-cleaner-status-${c.id}`}>
              <Icon className="w-3.5 h-3.5" /> {c.status_label}
            </span>
          </div>
        );
      })}
    </div>
  );
}

export default function MapPage() {
  const data = useLiveMap(30000);
  return (
    <div data-testid="map-page">
      <PageHeader eyebrow="Today · Live" title="Live Map"
        description="Where each cleaner is working right now. Live GPS is shared only while a job is in progress; otherwise pins show the booking they're scheduled at." />
      <div className="grid grid-cols-1 xl:grid-cols-4 gap-6">
        <div className="xl:col-span-3"><LiveMap data={data} height={600} /></div>
        <div>
          <div className="label-caps text-muted-foreground mb-3">Cleaners</div>
          <CleanerLegend cleaners={data?.cleaners} />
          <div className="mt-6 text-xs text-muted-foreground space-y-1.5">
            <div className="flex items-center gap-2"><span className="w-3 h-3 rounded-full border-2 border-[#9b8fa0] bg-[#9b8fa0]/25" /> Today's bookings</div>
            <div>Pins pulse when live GPS is on. Updates every 30 seconds.</div>
          </div>
        </div>
      </div>
    </div>
  );
}
